import {
  TableCellAttribute,
  TableCellStyles,
  TableConstructorData,
  TableData,
} from 'src/app/interfaces/tables.interfaces';

export class TableConstructorDataFactory {
  public createTableConstructorData(
    data: TableData,
    cellAttributes: TableCellAttribute[],
    cellStyles: TableCellStyles,
  ): TableConstructorData {
    return { data, cellAttributes, cellStyles };
  }
}
